import React, { forwardRef } from 'react';
import css from './group.module.scss';
import ArrowIcon from '../../images/arrow-icon.svg';
import { classNames, Mods } from '../../../../../shared/libs/classNames';
import { ITagsGroup } from '../../../../../entities/template/private-template-tag-group/template-tag-group/api/types';
// eslint-disable-next-line max-len
import { IWorkshopTagsGroup } from '../../../../../entities/module/tag-group/workshop-module-tag-group/model/types/types';

interface TagScrollSearchGroupProps {
	data: ITagsGroup | IWorkshopTagsGroup,
	isOpen: boolean,
	onClick: (id: string) => void,
	selected?: boolean,
	hasSelectedTags?: boolean,
}

export const TagScrollSearchGroup = forwardRef<HTMLDivElement, TagScrollSearchGroupProps>(
	({
		data,
		isOpen,
		onClick,
		selected = false,
		hasSelectedTags = false,
	}, ref) => {
		const mods: Mods = {
			[css.open]: isOpen,
			[css.selected]: selected,
			[css.highlight]: hasSelectedTags,
		};

		return (
			<div
				ref={ref}
				role="presentation"
				onClick={() => onClick(String(data.id))}
				className={classNames(css.wrapper, mods)}
			>
				<div className={css.text}>{data.name}</div>
				<div className={css.icon}>
					<ArrowIcon />
				</div>
			</div>
		);
	},
);
